



















































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { ShoppingCart } from '@/entities/ShoppingCart';
import { EmptyShoppingCartIcon } from '@/components/icons/EmptyShoppingCartIcon';
import { MoreIcon } from '@/components/icons/MoreIcon';
import { LessIcon } from '@/components/icons/LessIcon';
import { UploadIcon } from '@/components/icons/UploadIcon';
import { FilledShoppingCartIcon } from '@/components/icons/FilledShoppingCartIcon';
import { DeleteIcon } from '@/components/icons/DeleteIcon';
import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import { LoadingState } from '@/entities/LoadingState';
import { ShoppingCartModuleTypes } from '@/store/modules/shopping-cart';
import AddCart from '@/components/shopping-cart/menu/AddCart.vue';
import BaseMixin from '@/mixins/BaseMixin';
import { GoToCartEntry } from './GoToCartEntry';
import { CartSelect } from './CartSelect';
import { UserHelper } from '@/helper/user';
import DirectInput from '@/components/shopping-cart/menu/DirectInput.vue';
import CartItems from '@/components/shopping-cart/menu/CartItems.vue';

@Component({
    components: {
        LoadingIndicator,
        EmptyShoppingCartIcon,
        FilledShoppingCartIcon,
        GoToCartEntry,
        CartSelect,
        DeleteIcon,
        MoreIcon,
        LessIcon,
        UploadIcon,
        AddCart,
        DirectInput,
        CartItems,
    },
})
export default class ShoppingCartMenu extends Mixins(BaseMixin) {
    @Prop(String)
    private shoppingCartUrl!: string;
    @Prop(String)
    private partDetailLink!: string;

    private showAddCart: boolean = false;

    public get itemCount(): number {
        return this.activeShoppingCart == null ? 0 : this.activeShoppingCart.cartItems.length;
    }

    public get shoppingCarts(): ShoppingCart[] {
        return this.$store.getters[ShoppingCartModuleTypes.getters.shoppingCarts];
    }

    public get activeShoppingCart(): ShoppingCart | null {
        return this.$store.getters[ShoppingCartModuleTypes.getters.activeShoppingCart] as ShoppingCart | null;
    }

    public get isLoading(): boolean {
        return (
            (this.$store.getters[ShoppingCartModuleTypes.getters.loadingState] as LoadingState) === LoadingState.Loading
        );
    }

    public get isUserAuthenticated(): boolean {
        return UserHelper.isAuthenticated();
    }

    private addCart(cartName: string): void {
        this.$store.dispatch(ShoppingCartModuleTypes.actions.addShoppingCart, {
            cartName,
        });
        this.toggleAddCart();
    }

    private deleteActiveCart(): void {
        this.$store.dispatch(ShoppingCartModuleTypes.actions.deleteActiveShoppingCart);
    }

    private toggleAddCart(): void {
        this.showAddCart = !this.showAddCart;
    }

    private selectCart(event: Event): void {
        const id = event.target && parseInt((event.target as HTMLSelectElement).value, 10);
        if (!id || isNaN(id) || this.shoppingCarts.find((cart) => cart.id === id) == null) {
            return;
        }

        this.$store.dispatch(ShoppingCartModuleTypes.actions.setActiveShoppingCart, { shoppingCartId: id });
    }
}
